import {SignerTransaction} from "@perawallet/connect/dist/util/model/peraWalletModels";
import algosdk from "algosdk";

const algod = new algosdk.Algodv2('', 'https://node.algoexplorerapi.io', '');

async function generateOptIntoAssetTxns({
  assetID,
  initiatorAddr
}: {
  assetID: number;
  initiatorAddr: string;
}): Promise<SignerTransaction[]> {
  const suggestedParams = await algod.getTransactionParams().do();
  const optInTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
    from: initiatorAddr,
    to: initiatorAddr,
    assetIndex: assetID,
    amount: 0,
    suggestedParams
  });

  return [{txn: optInTxn, signers: [initiatorAddr]}];
}

async function generatePaymentTxns({
  to,
  initiatorAddr
}: {
  to: string;
  initiatorAddr: string;
}) {
  const suggestedParams = await algod.getTransactionParams().do();

  const txn = algosdk.makePaymentTxnWithSuggestedParamsFromObject({
    from: initiatorAddr,
    to,
    amount: 1,
    suggestedParams
  });

  return [{txn, signers: [initiatorAddr]}];
}

async function generateAssetTransferTxns({
  to,
  assetID,
  initiatorAddr,
  amount1,
  notes,
}: {
  to: string;
  assetID: number;
  initiatorAddr: string;
  amount1: number;
  notes: Uint8Array;
}) {
  const suggestedParams = await algod.getTransactionParams().do();

  const txn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
    from: initiatorAddr,
    to,
    assetIndex: assetID,
    amount: amount1,
    note: notes,
    suggestedParams
  });

  return [{txn, signers: [initiatorAddr]}];
}

export {generateOptIntoAssetTxns, generatePaymentTxns, generateAssetTransferTxns};
